/**
 * @generated SignedSource<<70f595af4e5492dd6a1b3a05549cdac1>>
 * @relayHash 9e22f1e1299d70beda82eb9975062332
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6129116a11542e99b3051cc484b01add4820c29c6062d2601b0b2c1a15d0d807

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluencePricingEndOfTrialPremiumToStandardQuery$variables = {
  cloudId: string;
  productKey: string;
};
export type ConfluencePricingEndOfTrialPremiumToStandardQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly experienceCapabilities?: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null | undefined;
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly premiumPrice?: ReadonlyArray<{
          readonly listPriceForOrderWithDefaults: ReadonlyArray<{
            readonly averageAmountPerUnit: number | null | undefined;
            readonly item: {
              readonly chargeElement: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined> | null | undefined;
        readonly standardPrice?: ReadonlyArray<{
          readonly listPriceForOrderWithDefaults: ReadonlyArray<{
            readonly averageAmountPerUnit: number | null | undefined;
            readonly item: {
              readonly chargeElement: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined> | null | undefined;
        readonly subscription?: {
          readonly trial: {
            readonly endTimestamp: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type ConfluencePricingEndOfTrialPremiumToStandardQuery = {
  response: ConfluencePricingEndOfTrialPremiumToStandardQuery$data;
  variables: ConfluencePricingEndOfTrialPremiumToStandardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productKey"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v3 = {
  "concreteType": "CcpEntitlementExperienceCapabilities",
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "offeringName",
          "value": "standard"
        }
      ],
      "concreteType": "CcpChangeOfferingExperienceCapability",
      "kind": "LinkedField",
      "name": "changeOfferingV2",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isAvailableToUser"
        },
        {
          "kind": "ScalarField",
          "name": "experienceUrl"
        }
      ],
      "storageKey": "changeOfferingV2(offeringName:\"standard\")"
    }
  ]
},
v4 = {
  "concreteType": "CcpTrial",
  "kind": "LinkedField",
  "name": "trial",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endTimestamp"
    }
  ]
},
v5 = [
  {
    "kind": "Literal",
    "name": "offeringName",
    "value": "Standard"
  }
],
v6 = {
  "concreteType": "CcpListPriceEstimate",
  "kind": "LinkedField",
  "name": "listPriceForOrderWithDefaults",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "averageAmountPerUnit"
    },
    {
      "concreteType": "CcpPricingPlanItem",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "chargeElement"
        }
      ]
    }
  ]
},
v7 = [
  (v6/*: any*/)
],
v8 = [
  {
    "kind": "Literal",
    "name": "offeringName",
    "value": "Premium"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = [
  (v6/*: any*/),
  (v10/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ConfluencePricingEndOfTrialPremiumToStandardQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      {
                        "concreteType": "CcpSubscription",
                        "kind": "LinkedField",
                        "name": "subscription",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "alias": "standardPrice",
                        "args": (v5/*: any*/),
                        "concreteType": "CcpEntitlementOfferingTransition",
                        "kind": "LinkedField",
                        "name": "defaultOfferingTransitions",
                        "plural": true,
                        "selections": (v7/*: any*/),
                        "storageKey": "defaultOfferingTransitions(offeringName:\"Standard\")"
                      },
                      {
                        "alias": "premiumPrice",
                        "args": (v8/*: any*/),
                        "concreteType": "CcpEntitlementOfferingTransition",
                        "kind": "LinkedField",
                        "name": "defaultOfferingTransitions",
                        "plural": true,
                        "selections": (v7/*: any*/),
                        "storageKey": "defaultOfferingTransitions(offeringName:\"Premium\")"
                      }
                    ],
                    "type": "CcpEntitlement"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConfluencePricingEndOfTrialPremiumToStandardQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      {
                        "concreteType": "CcpSubscription",
                        "kind": "LinkedField",
                        "name": "subscription",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v10/*: any*/)
                        ]
                      },
                      {
                        "alias": "standardPrice",
                        "args": (v5/*: any*/),
                        "concreteType": "CcpEntitlementOfferingTransition",
                        "kind": "LinkedField",
                        "name": "defaultOfferingTransitions",
                        "plural": true,
                        "selections": (v11/*: any*/),
                        "storageKey": "defaultOfferingTransitions(offeringName:\"Standard\")"
                      },
                      {
                        "alias": "premiumPrice",
                        "args": (v8/*: any*/),
                        "concreteType": "CcpEntitlementOfferingTransition",
                        "kind": "LinkedField",
                        "name": "defaultOfferingTransitions",
                        "plural": true,
                        "selections": (v11/*: any*/),
                        "storageKey": "defaultOfferingTransitions(offeringName:\"Premium\")"
                      }
                    ],
                    "type": "CcpEntitlement"
                  },
                  (v10/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "9e22f1e1299d70beda82eb9975062332",
    "id": "6129116a11542e99b3051cc484b01add4820c29c6062d2601b0b2c1a15d0d807",
    "metadata": {},
    "name": "ConfluencePricingEndOfTrialPremiumToStandardQuery",
    "operationKind": "query",
    "text": "query ConfluencePricingEndOfTrialPremiumToStandardQuery($cloudId:ID!,$productKey:String!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:$productKey){__typename,entitlement{__typename,...on CcpEntitlement{experienceCapabilities{changeOfferingV2(offeringName:\"standard\"){isAvailableToUser,experienceUrl}},subscription{trial{endTimestamp},id},standardPrice:defaultOfferingTransitions(offeringName:\"Standard\"){listPriceForOrderWithDefaults{averageAmountPerUnit,item{chargeElement}},id},premiumPrice:defaultOfferingTransitions(offeringName:\"Premium\"){listPriceForOrderWithDefaults{averageAmountPerUnit,item{chargeElement}},id}},id}}}}"
  }
};
})();

(node as any).hash = "6058f9f9973b1c1fa71040e1c9f701e8";

export default node;
